<template>

    <div id="lesson-chat-service">

        <div id="fileUpload" class="position-right" style="display:none">
            <file-upload name="file" input-id="lesson-chatroom-file" class="btn btn-primary"
                extensions="jpeg,jpg,gif,pdf,png,webp,doc,docx"
                accept="image/png, application/pdf, image/gif, image/jpeg, image/webp, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                v-model="files"
                post-action="/uploader/fileUploader" :data="{
                    'current_chatbox_userid': this.current_chatbox_userid,
                    'message_type': this.$props.user_info.user_type,
                    'folder': 'notes',
                }" :headers="{ 'X-CSRF-TOKEN': this.csrf_token }" :multiple="true" :drop="true" :drop-directory="true"
                @input="updatetValue" @input-file="inputFile" @input-filter="inputFilter" ref="upload">
            </file-upload>  
        </div>


        <div class="chatbox-container">


            <div class="card">
                <div class="card-body bg-white pb-4" style="min-height:325px;">

                    <div id="user-chatlog" class="user-chatlog border rounded text-center">
                        <div class="chatlog-wrapper">

                            <div class="chat mt-1 p-1" v-for="(chatlog, chatlogIndex) in messages"
                                :key="'my_chatlog_' + chatlogIndex">
                                <div v-if="current_chatbox_userid == chatlog.sender.userid">
                                    <div class="sender-container">
                                        <div class="sender-wrapper text-right small">
                                            <div class="sender small text-right"
                                                v-if="chatlogIndex >= 1 && messages[chatlogIndex - 1].sender.type !== messages[chatlogIndex].sender.type">
                                                {{ chatlog.sender.nickname }}
                                            </div>
                                            <div class="sender small text-right" v-if="chatlogIndex == 0">
                                                {{ chatlog.sender.nickname }}
                                            </div>

                                            <div class="message-container">
                                                <div class="message">
                                                    <span v-html="chatlog.message"></span>
                                                    <div class="small text-align-right">
                                                        <span class="small font-italic text-secondary">{{ chatlog.time
                                                            }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>

                                    <div class="recipient-container">
                                        <div class="recipient-wrapper text-left small">
                                            <div class="sender small text-left"
                                                v-if="chatlogIndex >= 1 && messages[chatlogIndex - 1].sender.type !== messages[chatlogIndex].sender.type">
                                                {{ chatlog.sender.nickname }}
                                            </div>

                                            <div class="sender small text-left" v-if="chatlogIndex == 0">
                                                {{ chatlog.sender.nickname }}
                                            </div>

                                            <div class="message-container">
                                                <div class="message">
                                                    <span v-html="chatlog.message"></span>
                                                    <div class="text-align-left">
                                                        <span class="font-italic text-secondary">{{ chatlog.time
                                                            }}</span>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div class="strike" v-if="unreadMessages.length >= 1">
                                <span class="small">Unread Message(s)</span>
                            </div>

                            <div class="chat mt-1 p-1" v-for="(chatlog, chatlogIndex) in unreadMessages"
                                :key="'my_unread_chatlog_' + chatlogIndex">
                                <div v-if="current_chatbox_userid == chatlog.sender.userid">
                                    <div class="sender-container">
                                        <div class="sender-wrapper text-right small">
                                            <div class="sender small text-right"
                                                v-if="chatlogIndex >= 1 && unreadMessages[chatlogIndex - 1].sender.type !== unreadMessages[chatlogIndex].sender.type">
                                                {{ chatlog.sender.nickname }}
                                            </div>
                                            <div class="sender small text-right" v-if="chatlogIndex == 0">
                                                {{ chatlog.sender.nickname }}
                                            </div>

                                            <div class="message-container">
                                                <div class="message small">
                                                    <span v-html="chatlog.message"></span>
                                                    <div class="small text-align-right">
                                                        <span class="small font-italic text-secondary">{{ chatlog.time
                                                            }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="recipient-container">
                                        <div class="recipient-wrapper text-left small">
                                            <div class="sender small text-left"
                                                v-if="chatlogIndex >= 1 && unreadMessages[chatlogIndex - 1].sender.type !== unreadMessages[chatlogIndex].sender.type">
                                                {{ chatlog.sender.nickname }}
                                            </div>

                                            <div class="sender small text-left" v-if="chatlogIndex == 0">
                                                {{ chatlog.sender.nickname }}
                                            </div>

                                            <div class="message-container">
                                                <div class="message small">
                                                    <span v-html="chatlog.message"></span>
                                                    <div class="small text-align-right">
                                                        <span class="small font-italic text-secondary">{{ chatlog.time
                                                            }}</span>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div class="strike" v-if="newMessageAdded == true">
                                <span class="small">Recent Message(s)</span>
                            </div>

                            <div class="chat mt-1 p-1" v-for="(chatlog, chatlogIndex) in recentMessages"
                                :key="'recent_message_log' + chatlogIndex">
                                <div v-if="current_chatbox_userid == chatlog.sender.userid">
                                    <div class="sender-container">
                                        <div class="sender-wrapper text-right small">
                                            <div class="sender small text-right"
                                                v-if="chatlogIndex >= 1 && recentMessages[chatlogIndex - 1].sender.type !== recentMessages[chatlogIndex].sender.type">
                                                {{ chatlog.sender.nickname }}
                                            </div>
                                            <div class="sender small text-right" v-if="chatlogIndex == 0">
                                                {{ chatlog.sender.nickname }}
                                            </div>

                                            <div class="message-container">
                                                <div class="message small">
                                                    <span v-html="chatlog.message"></span>
                                                    <div class="small text-align-right">
                                                        <span class="small font-italic text-secondary">{{ chatlog.time
                                                            }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="recipient-container">
                                        <div class="recipient-wrapper text-left small">
                                            <div class="sender small text-left"
                                                v-if="chatlogIndex >= 1 && recentMessages[chatlogIndex - 1].sender.type !== recentMessages[chatlogIndex].sender.type">
                                                {{ chatlog.sender.nickname }}
                                            </div>

                                            <div class="sender small text-left" v-if="chatlogIndex == 0">
                                                {{ chatlog.sender.nickname }}
                                            </div>

                                            <div class="message-container">
                                                <div class="message small">
                                                    <span v-html="chatlog.message"></span>
                                                    <div class="small text-align-right">
                                                        <span class="small font-italic text-secondary">{{ chatlog.time
                                                            }}</span>
                                                    </div>
                                                </div>


                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>


                            <div v-for="(file, index) in files" :key="file.id"
                                class="image-prieview-container bg-light  w-25 d-inline-block p-1 border border-light rounded">

                                <div class="remove-image-upload float-right">
                                    <a class="" href="#" @click.prevent="$refs.upload.remove(file)"
                                        style="padding:5px; background-color:#fff; color:#000">X</a>
                                </div>

                                <div v-if="file.type == 'image/jpeg' || file.type == 'image/png'">
                                    <img class="w-100" :src="file.thumb" :id="'image-preview-' + index">
                                </div>

                                <div v-else>
                                    <div>
                                        <i class="far fa-file" style="font-size:110px"></i>
                                    </div>
                                </div>

                                <div class="progress" v-if="file.active || file.progress !== '0.00'">
                                    <div :class="{ 'progress-bar': true, 'progress-bar-striped': true, 'bg-danger': file.error, 'progress-bar-animated': file.active }"
                                        role="progressbar" :style="{ width: file.progress + '%' }">{{ file.progress }}%
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>


                    <div id="user-reply-container" class="row mt-2">

                        <!--
                        <div class="col-9 pr-0 mr-0">
                            <div v-for="(file, index) in files" :key="file.id"
                                class="image-prieview-container bg-light  w-25 d-inline-block p-1 border border-light rounded">

                                <div class="remove-image-upload float-right">
                                    <a class="" href="#" @click.prevent="$refs.upload.remove(file)"
                                        style="padding:5px; background-color:#fff; color:#000">X</a>
                                </div>

                                <div v-if="file.type == 'image/jpeg' || file.type == 'image/png'">
                                    <img class="w-100" :src="file.thumb" :id="'image-preview-' + index">
                                </div>

                                <div v-else>
                                    <div>
                                        <i class="far fa-file" style="font-size:110px"></i>
                                    </div>
                                </div>

                                <div class="progress" v-if="file.active || file.progress !== '0.00'">
                                    <div :class="{ 'progress-bar': true, 'progress-bar-striped': true, 'bg-danger': file.error, 'progress-bar-animated': file.active }"
                                        role="progressbar" :style="{ width: file.progress + '%' }">{{ file.progress }}%
                                    </div>
                                </div>

                            </div>
                        </div>
                        -->


                        <div class="paste-area col-8 pr-1" @paste="handlePaste">

                            <!--
                            <input id="message" 
                                v-on:keyup.13="sendMessage(privateMessage)"  
                                type="text" 
                                autocomplete="off"
                                class="form-control form-control-sm mb-1" 
                                v-model="privateMessage" 
                                placeholder="Type a message" 
                                aria-label="Type a message"
                                :config="editorConfig"
                            >
                            -->
                           
                            <vue-ckeditor id="message" ref="ckeditorMessage" v-model="privateMessage"
                                :config="editorConfig" />



                        </div>
                        <div class="col-4 px-0">

                            <div id="attach-button" class="input-group-append d-inline-block float-left">
                                <label id="file-select-button" for="lesson-chatroom-file"
                                    class="custom-btn-input btn btn-primary btn-sm">
                                    <i class="fas fa-paperclip"></i>
                                </label>
                            </div>

                            <div id="send-button" class="input-group-append d-inline-block float-left">
                                <button type="button"
                                    @click.prevent="$refs.upload.active = false; sendMessage(privateMessage);"
                                    class="custom-btn-input btn btn-sm btn-primary">
                                    <i class="fa fa-paper-plane" aria-hidden="true"></i>
                                </button>
                            </div>

                            <span class="button-controls" style=" display:none">
                                <button id="startUpload" type="button" class="btn btn-sm btn-success"
                                    v-if="!$refs.upload || !$refs.upload.active"
                                    @click.prevent="$refs.upload.active = true">
                                    <i class="fa fa-arrow-up" aria-hidden="true"></i>Start Upload
                                </button>

                                <button type="button" class="btn btn-sm btn-danger" v-else
                                    @click.prevent="$refs.upload.active = false">
                                    <i class="fa fa-stop" aria-hidden="true"></i>Stop Upload
                                </button>
                            </span>



                        </div>

                    </div>

                </div>
            </div>

        </div>

        <ImageViewerComponent ref="ImageViewerComponent" />

    </div>
</template>

<script>
import io from "socket.io-client";
import FileUpload from 'vue-upload-component'
import ImageViewerComponent from "../../image/imageViewerComponent.vue"
import VueCkeditor from 'vue-ckeditor2'

var socket = null;

export default {
    name: "lessonSliderChatroomComponent",
    components: {
        FileUpload, ImageViewerComponent, VueCkeditor
    },
    data() {

        return {


            privateMessage: "",

            editorConfig: {
                resize_enabled: false,         // disables resizing
                toolbar: ['bold'],
                removePlugins: ['elementspath', 'easyimage', 'cloudservices', 'exportpdf', 'resize'],
                height: 50,
                uiColor: 'transparent',
                contentsCss: [
                    'body { margin: -5px 5px 0px !important; padding: 0 !important; font-family: Arial, sans-serif !important; font-size: 14px; background: transparent; color: #000; }'
                ]
                /*
                on: 
                {
                    paste: (evt) => {
               
                  
                                                    
                    }   
                } 
                */
            },



            //history is fetching status
            isFetching: false,
            interval: "",

            //first load on opening chatbox
            firstLoad: true,



            messages: [],

            unreadMessages: [],
            recentMessages: [],


            users: [],

            //chat boxes
            message_count: 0,
            unread_message_count: 0,


            //this will hold the current recipient userid
            current_chatbox_userid: "",

            //uploader
            files: [],

            //History Loaders
            loadingHistory: false,
            historyNotifier: true,

            //buttons
            ButtonSend: null,
            ButtonUpload: null,

            //page
            page: [],


            newMessageAdded: false,
        };
    },
    props: {
        userid: String,
        username: String,
        nickname: String,
        user_image: String,
        api_token: String,
        csrf_token: String,
        chatserver_url: String,
        show_sidebar: Boolean,

        channelid: {
            type: [String, Number],
            required: true
        },
        canvas_server: {
            type: [String],
            required: true
        },
        user_info: {
            type: [Object, String],
            required: true
        },
        member_info: {
            type: [Object, String],
            required: true
        },
        recipient_info: {
            type: [Object, String],
            required: true
        },
        isBroadcaster: {
            type: [Boolean],
            required: true
        },

    },

    mounted() {

        //Transfer the object to the window
        window.lessonSliderChatroom = this;

        this.socket = io(this.$props.canvas_server, {
            reconnection: true,          // auto-reconnect
            reconnectionAttempts: 10,     // how many tries
            reconnectionDelay: 1000      // delay between attempts
        });

        let user = this.getUser();

        this.socket.emit('REGISTER', user);

        this.socket.on('SEND_SLIDE_PRIVATE_MESSAGE', (response) => {
            new Promise((resolve, reject) => {
                this.newMessageAdded = true;
                this.markMessageRead();
                this.pushPrivateMessage(response);
                resolve('private message resolved');
            }).then((result) => {
                this.message = null;
                this.scrollToEnd();
            });
        });





        this.getChatHistory();

        window.addEventListener("keyup", (e) => {
            this.prepareButtons();
        });


        this.initializeChatBox(user);

        //add the image viewer
        document.body.addEventListener("click", this.imageViewerClick);


        if (window.CKEDITOR) {
            CKEDITOR.on('instanceReady', (evt) => {
                const editor = evt.editor; // CKEditor instance
                if (editor.name === 'message') { // match by id if needed
                    this.onEditorReady(editor);
                }
            });
        }




    },
    beforeDestroy() {
        window.removeEventListener('paste', this.handlePaste);

    },
    methods: {

        handleKeyDown(event) {
            if (event.ctrlKey) {
                console.log("🔹 Ctrl pressed ");
            }
        },
        imageViewerClick(event) {
            // Check if the clicked element has the "img_preview" class
            if (event.target.classList.contains("img_preview")) {
                event.preventDefault();
                // Extract the image URL from the clicked element and open the modal
                const imageUrl = event.target.getAttribute("src");

                //this.$refs.ImageViewerComponent.isModalOpen = true; // Open the modal
                //this.$refs.ImageViewerComponent.modalImageUrl = imageUrl; // Set the image URL

                this.$refs.ImageViewerComponent.openModal(imageUrl); // Open the modal

            }
        },

        popUpImage(index, message) {
            return false;
        },
        getUser() {

            if (this.$props.user_info.user_type == "MEMBER") {
                return {
                    channelid: this.channelid,
                    userid: this.$props.member_info.user_id,
                    username: this.$props.member_info.username,
                    nickname: this.$props.member_info.nickname,
                    user_image: this.user_image,
                    type: this.$props.user_info.user_type,
                    status: 'online',
                    chat_type: 'sender'
                }
            } else if (this.$props.user_info.user_type == "TUTOR") {
                return {
                    channelid: this.channelid,
                    userid: this.$props.member_info.user_id,
                    username: this.$props.user_info.username,
                    nickname: this.$props.user_info.firstname,
                    user_image: this.user_image,
                    type: this.$props.user_info.user_type,
                    status: 'online',
                    chat_type: 'sender'
                }
            }
        },
        getRecipient() {
            return this.$props.recipient_info;
        },
        pushPrivateMessage(data) {
            this.recentMessages.push(data);
        },
        sendMessage: function (message) {

            this.privateMessage = message;

            //files is empty and message is empty, stop sending message
            if (this.files.length == 0 && message === "" || message === undefined) {
                //console.log("no message")
                return false;
            }
            else if (this.files.length >= 1 && message === "") {
                //console.log("upload file only")     
                //upload the file only
                const uploader = this.$refs.upload;
                if (uploader) {
                    uploader.active = true;
                }
            } else if (this.files.length >= 1 && message !== "") {
                //upload both
                //console.log("both files and message")
                const uploader = this.$refs.upload;
                if (uploader) {
                    uploader.active = true;
                    console.log("m4")
                }
            } else if (this.files.length == 0 && message !== "") {
                //console.log("send message only")
                this.emitMessage(this.privateMessage);
                this.privateMessage = "";
                this.$forceUpdate();
                this.$nextTick(() => {
                    this.scrollToEnd();
                    this.prepareButtons();
                });
            }
        },
        emitMessage(message) {

            var currentTime = new Date();
            let channelid = this.channelid;
            let time = currentTime.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false })

            let sender = this.getUser();
            let recipient = this.getRecipient();

            this.socket.emit("SEND_SLIDE_PRIVATE_MESSAGE", { channelid, time, recipient, sender, message });

            axios.post("/api/saveLessonChat?api_token=" + this.api_token,
                {
                    method: "POST",
                    channelid: this.channelid,
                    sender_id: sender.userid,
                    recipient_id: recipient.userid,
                    message: message,
                    is_read: false,
                    valid: true,
                    message_type: sender.type,

                }).then(response => {
                    if (response.data.success === true) {
                        //@todo: HIGHLIGHT or add confirmation
                    } else {
                        //@todo: HIGHLIGHT error
                    }
                }).catch(function (error) {
                    console.log("Error " + error);
                });
        },
        markMessageRead() {
            this.scrollToEnd();

            axios.post("/api/markLessonChatMessagesRead?api_token=" + this.api_token, {
                method: "POST",
                channelid: this.channelid
            }).then(response => {
                //console.log("marked read")
            });
        },
        getChatHistory() {

            this.isFetching = true;

            let channelid = this.channelid;

            //user is the sender
            axios.post("/api/getLessonChathistory?api_token=" + this.api_token,
                {
                    method: "POST",
                    channelid: channelid
                }).then(response => {

                    if (response.data.success === true) {

                        this.isFetching = false;


                        //unread
                        let unreadChatHistoryItems = response.data.unreadChatHistoryItems

                        unreadChatHistoryItems.forEach(data => {
                            let message = data.message;
                            let time = data.created_at;

                            let sender = {
                                userid: data.sender_id,
                                username: this.$props.member_info.username,
                                nickname: data.nickname ?? data.firstname,
                                type: data.message_type
                            }

                            let recipient = {
                                userid: data.recipient_id,
                                //nickname:   "recipient",
                                type: data.message_type
                            }

                            this.unreadMessages.unshift({ channelid, time, recipient, sender, message });
                        });


                        //read
                        let readChatHistoryItems = response.data.readChatHistoryItems

                        readChatHistoryItems.forEach(data => {
                            let message = data.message;
                            let time = data.created_at;

                            let sender = {
                                userid: data.sender_id,
                                username: this.$props.member_info.username,
                                nickname: data.nickname ?? data.firstname,
                                type: data.message_type
                            }

                            let recipient = {
                                userid: data.recipient_id,
                                //nickname:   "recipient",
                                type: data.message_type
                            }

                            this.messages.unshift({ channelid, time, recipient, sender, message });
                        });

                        this.$nextTick(() => {
                            this.scrollToEnd();
                        });

                    }
                });

        },
        scrollToTop: function () {
            this.$forceUpdate();

            var container = this.$el.querySelector("#user-chatlog");
            if (container) {
                container.scrollTop = 0;
            }
        },

        onEditorReady(editor) {
            console.log("✅ CKEditor ready!");

            editor.on('key', (evt) => {

                const keyCode = evt.data.keyCode; // numeric key code
                const isCtrl = evt.data.domEvent.$.ctrlKey; // true if Ctrl is pressed

                if (keyCode === 13) {
                    evt.cancel();
                    this.sendMessage(this.privateMessage)
                }

                /*
                if (isCtrl) {                  
                    console.log('🖨️ Ctrl pressed inside CKEditor');
                }
                */
            });


            editor.on('paste', (evt) => {
                console.log("pasted");
                this.handlePasteImage(evt);

                setTimeout(() => {
                    this.scrollToEnd();
                }, 500);


            });


        },

        async handlePasteImage(evt) {
            try {
                const items = await navigator.clipboard.read();

                for (const item of items) {
                    for (const type of item.types) {
                        if (type.startsWith("image/")) {
                            const blob = await item.getType(type);
                            // Optional: give it a name
                            const timestamp = Date.now();
                            const namedFile = new File([blob], `pasted_${timestamp}.png`, { type: blob.type });

                            console.log("📸 Real clipboard image detected:", namedFile);
                            // 👇 Add file to uploader (if using vue-upload-component)
                            if (this.$refs.upload) this.$refs.upload.add(namedFile);


                            evt.cancel();
                            return; // stop after first image found
                        }
                    }
                }

                console.warn("⚠️ No image found in clipboard");
                //this.handlePasteHtml(evt)?.();
                setTimeout(() => {
                    this.scrollToEnd();
                }, 500);


            } catch (err) {
                console.error("❌ Clipboard image read failed:", err);
            }
        },
        async handlePasteHtml(evt) {
            try {
                const items = await navigator.clipboard.read(); // full clipboard items
                for (const item of items) {
                    for (const type of item.types) {
                        if (type === 'text/html') {
                            const blob = await item.getType(type);
                            const html = await blob.text();

                            
                            // insert into CKEditor (preserves formatting)
                            const editor = this.$refs.ckeditorMessage.instance;
                            if (editor) {
                                //editor.setData(this.privateMessage + " " + html); // replaces content
                                 editor.insertHtml(html); // appends at cursor
                            }
                            console.log("🧩 HTML content pasted with formatting");

                            evt.cancel();

                            return;
                        }
                    }
                }

                console.warn("⚠️ No HTML content found in clipboard");

            } catch (err) {
                console.error("❌ Clipboard read failed:", err);
            }
        },

     

        // helper: convert Blob to base64 string
        blobToBase64(blob) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        },



        async handlePasteText() {
            try {
                // Read text from the system clipboard (requires HTTPS or localhost)
                const text = await navigator.clipboard.readText();

                // Assign to your v-model
                this.privateMessage = this.privateMessage  + "  " + text;

                console.log("📋 Copied text pasted into privateMessage:", text);
            } catch (err) {
                console.warn("⚠️ Unable to read clipboard:", err);
            }
        },
        handlePaste(event) {

            const items = event.clipboardData?.items || window.clipboardData;

            console.log("✅ handlePaste Event Fired");

            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                if (item.type.indexOf('image') !== -1) {
                    const file = item.getAsFile();

                    const timestamp = Date.now();
                    const namedFile = new File([file], `pasted_${timestamp}.png`, {
                        type: file.type,
                    });

                    // 👇 Send it to your uploader
                    this.$refs.upload.add(namedFile);
                    console.log("📸 Image pasted and added to uploader:", namedFile);
                    break;
                } else {
                    console.log("No Image ");

                    this.handlePasteHtml();
                }
            }
        },

        updatetValue(value) {
            //this.files = value;
        },
        /**
         * Has changed
         * @param  Object|undefined   newFile   Read only
         * @param  Object|undefined   oldFile   Read only
         * @return undefined
         */
        inputFile: function (newFile, oldFile) {

            console.log(newFile, oldFile);

            this.prepareButtons();

            if (newFile && oldFile && !newFile.active && oldFile.active) {
                if (newFile.xhr) {
                    if (newFile.xhr.status === 200) {


                        //file information
                        let file = [{
                            'id': newFile.response.id,
                            'file_name': newFile.response.file,
                            'size': newFile.response.size,
                        }];

                        this.emitMessage(newFile.response.image);

                        if (this.privateMessage !== '') {
                            this.emitMessage(this.privateMessage);
                            this.privateMessage = "";
                        }


                    }

                }
            }

            if (this.$refs.upload.uploaded) {
                // console.log("all queue uploaded");
                this.files = [];
                this.scrollToEnd();
            }


            setTimeout(() => {
                this.scrollToEnd();
                console.log("attached files to upload...")
            }, 500);
        },
        /**
         * Pretreatment
         * @param  Object|undefined   newFile   Read and write
         * @param  Object|undefined   oldFile   Read only
         * @param  Function           prevent   Prevent changing
         * @return undefined
         */
        inputFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpe|jpg|gif|png|webp|pdf|doc|docx)$/i.test(newFile.name)) {
                    return prevent();
                }
            }


            if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
                // Create a blob field
                newFile.blob = ''
                let URL = window.URL || window.webkitURL
                if (URL && URL.createObjectURL) {
                    newFile.blob = URL.createObjectURL(newFile.file)
                }
                // Thumbnails
                newFile.thumb = ''
                if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
                    newFile.thumb = newFile.blob
                }
            }
        },
        prepareButtons: function () {
            //console.log(this.files.length);

            let message = document.getElementById("message").value;
            //let fileSelectBtn = document.getElementById("file-select-button");
            let sendBtn = document.getElementById("send-button");

            if (message == "" && this.files.length == 0) {

                /*
                if (fileSelectBtn) {
                    fileSelectBtn.style.display = "block";
                }
                */

                if (sendBtn) {
                    sendBtn.style.display = "none";
                }
            } else {
                
                /*
                if (fileSelectBtn) {
                    fileSelectBtn.style.display = "none";
                }
                    */

                if (sendBtn) {
                    sendBtn.style.display = "block";
                }
            }
        },

        initializeChatBox: function (user) {
            this.current_chatbox_userid = user.userid;
            this.messages = [];
            this.$forceUpdate();
            this.$nextTick(function () {
                this.scrollToEnd();
                this.prepareButtons();
            });
        },
        delayandMarkUnread() {
            console.log("delay fired")
            this.interval = setInterval(this.prepeareMarkRead, 1500);
        },
        prepeareMarkRead() {
            this.markMessagesRead(this.userid)
        },
        markMessagesRead(userid) {

            console.log("marking read")
            clearInterval(this.interval);

            axios.post("/api/markChatMessagesRead?api_token=" + this.api_token,
                {
                    method: "POST",
                    userID: userid,
                    message_type: 'CHAT_SUPPORT'
                }).then(response => {

                    if (response.data.success === true) {
                        this.unread_message_count = 0;
                        clearInterval(this.interval);

                    } else {
                        clearInterval(this.interval);
                    }
                });
        },
        updateUserList: function (users) {
            this.users = users;
            this.$forceUpdate();
        },
        scrollToEnd: function () {
            this.$forceUpdate();

            this.$nextTick(function () {
                var container = this.$el.querySelector("#user-chatlog");

                if (container) {
                    container.scrollTop = container.scrollHeight;
                }
            });

        },

    },
    computed: {},

};
</script>


<style>
.img_preview {
    width: 100%;
}

.custom-pdf {
    font-size: 100px;
}
</style>


<style scoped>
.img_preview {
    width: 100px;
}

#fileUpload {
    display: none;
}



.bg-blue {
    background-color: #009fd9
}

.border-blue {
    border-color: #009fd9
}


.custom-btn-input {
    margin-right: 2px;
    padding: 9px 9px;
    line-height: 0px;
    font-size: 10px;
}

.position-bottom-right {
    position: fixed;
    bottom: 0px;
    right: 75px;
    z-index: 9999;
}

#floating-history-btn {
    font-size: 11px;
    padding: 2px 5px 2px;
    position: absolute;
    top: 42px;
    left: 215px;
    z-index: 1;
}


.btn-xs {
    font-size: 11px;
    padding: 2px 5px 2px;
}

.chatlog-wrapper {
    margin-top: 5px;
}


.chat-button {
    border-radius: 50%;
    height: 65px;
    width: 65px;
    padding: 0px;
}


.user-chatlog {
    border: 1px solid #ececec;
    padding: 5px 5px 10px;
    min-height: 250px;
    max-height: 275px;
    margin-bottom: 3px;
    overflow-x: hidden;
    overflow-y: scroll;
}

.member-info {
    text-align: right;
}

.member-image {
    float: right;
    border-radius: 50%;
    margin-left: 30px;
    border: 3px solid #ededed;
}

/* SENDER BUBBLE */
.sender-container {
    width: 100%;
    clear: both;
}

.sender-container .message-container {
    position: relative;
    float: right;
}

.sender-container .message {
    position: relative;
    background-color: #DBF4FC;
    border-radius: .4em;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    padding: 5px 15px 5px;
    margin-bottom: 7px;
    text-align: left;
    font-size: 16px;
}


/* RECIPIENT BUBBLE */
.recipient-container {
    width: 100%;
    clear: both;
}

.recipient-container .message-container {
    position: relative;
    float: left;
}

.recipient-container .message {
    position: relative;
    background-color: #F2F6F9;
    border-radius: .4em;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    padding: 5px 15px 5px;
    margin-bottom: 7px;
    text-align: left;
    font-size: 16px;
}

.strike {
    display: block;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
}

.strike>span {
    position: relative;
    display: inline-block;
    font-size: 10px;
}

.strike>span:before,
.strike>span:after {
    content: "";
    position: absolute;
    top: 50%;
    width: 9999px;
    height: 1px;
    background: #ccc;
}

.strike>span:before {
    right: 100%;
    margin-right: 5px;
}

.strike>span:after {
    left: 100%;
    margin-left: 5px;
}
</style>